import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-foreground-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h4 className="text-lg font-bold font-heading text-background-50 mb-4">
              <Link to="/" className="hover:text-primary-300 transition-colors">
                韩漫之家
              </Link>
            </h4>
            <p className="text-sm text-foreground-400 leading-relaxed">
              免费韩国漫画在线阅读平台，海量资源持续更新，为您带来最佳的漫画阅读体验。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-500 transition-colors text-background-50" aria-label="微博">
                <i className="ri-weibo-line text-sm w-4 h-4 flex items-center justify-center"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-500 transition-colors text-background-50" aria-label="微信">
                <i className="ri-wechat-line text-sm w-4 h-4 flex items-center justify-center"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-500 transition-colors text-background-50" aria-label="QQ">
                <i className="ri-qq-line text-sm w-4 h-4 flex items-center justify-center"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold font-label text-background-50 mb-4 uppercase tracking-wider">
              漫画分类
            </h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 6).map(cat => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-400 hover:text-primary-300 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold font-label text-background-50 mb-4 uppercase tracking-wider">
              快速链接
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-400 hover:text-primary-300 transition-colors">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category/romance" className="text-sm text-foreground-400 hover:text-primary-300 transition-colors">
                  分类浏览
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-300 transition-colors">
                  关于我们
                </Link>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-400 hover:text-primary-300 transition-colors">
                  用户协议
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-400 hover:text-primary-300 transition-colors">
                  隐私政策
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold font-label text-background-50 mb-4 uppercase tracking-wider">
              联系我们
            </h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-sm text-foreground-400">
                <i className="ri-mail-line w-4 h-4 flex items-center justify-center"></i>
                <span>contact@hanmanzhijia.com</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-400">
                <i className="ri-phone-line w-4 h-4 flex items-center justify-center"></i>
                <span>400-888-6789</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-400">
                <i className="ri-map-pin-line w-4 h-4 flex items-center justify-center"></i>
                <span>北京市朝阳区望京SOHO</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-800/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 韩漫之家 - 免费韩国漫画在线阅读平台. 保留所有权利.
          </p>
          <p className="text-xs text-foreground-600">
            本站内容仅供学习交流使用，请支持正版漫画
          </p>
        </div>
      </div>
    </footer>
  );
}